import { useAppDispatch, useAppSelector } from "@/hooks";
import { UseAddressState, UseAddressType } from "../types/address";
import { useEffect, useState } from "react";

import { default as addressService } from "../services/address"
import { Address } from "@/components/form-fields/AddressForm/types/address";
import { ContractDisplayTypes } from "../types/contracts";
import { default as contractActions } from "@/components/Contracts/actions/newActions"
import axios, { AxiosError } from "axios";
import { useContracts } from "./useContracts";

export const useAddress =  (type: ContractDisplayTypes) => {
  const dispatch = useAppDispatch();

  const { currentContract } = useContracts(type);
  
  const availableAddresses = useAppSelector(state => state.contracts[type].addressess.available);
  const state = useAppSelector(state => state.contracts[type].addressess.status[currentContract!.id]?.status ?? "uninitialized");
  const errorCode = useAppSelector(state => state.contracts[type].addressess.status[currentContract!.id]?.error_code);

  useEffect(() => {
    if (state === "uninitialized") {
      fetchAddress();
    }
  }, [state]);

  const fetchAddress = async () => {
    dispatch(contractActions[type].addressFetching())
    addressService.fetchAddress()
    .then(data => {
      dispatch(contractActions[type].recievedAddress(data))
    })
    .catch(err => {
      if (axios.isAxiosError(err))  {
        dispatch(contractActions[type].notificationFormFailed(err.response?.data.errors))
      }
    })
  }

  const updateAddress = (
    addressId: number,
    contractName: string,
  ) => {
    dispatch(contractActions[type].notificationFormSubmited())
    
    // Crida a l'API utilitzant el servei
    addressService.updateAddress({ addressId, contractName, type })
    .then((res) => {
      dispatch(contractActions[type].notificationAddressUpdated(res.promise.data.address_id))
    })
    .catch(err => {
      if (axios.isAxiosError(err))  {
        dispatch(contractActions[type].notificationFormFailed(err.response?.data.errors))
      }
    })
  };

  const createAddress = (
    address: Address,
    contractName: string,
  ) => {
    dispatch(contractActions[type].notificationFormSubmited())

    // Crida a l'API utilitzant el servei
    addressService.createAddress({ address, contractName, type })
    .then((res) => {
      dispatch(contractActions[type].notificationAddressCreated(res.promise.data.address))
    })
    .catch(err => {
      if (axios.isAxiosError(err))  {
        dispatch(contractActions[type].notificationFormFailed(err.response?.data.errors))
      }
    })
  };

  const modifyAddress = (
    address: Address,
    contractName: string,
  ) => {
    dispatch(contractActions[type].notificationFormSubmited())

    addressService.modifyAddress({ address, contractName, type })
    .then((res) => {
      dispatch(contractActions[type].notificationAddressModified(res.promise.data.address))
    })
    .catch(err => {
      if (axios.isAxiosError(err))  {
        dispatch(contractActions[type].notificationFormFailed(err.response?.data.errors))
      }
    })
  };

  return {
    availableAddresses,
    errorCode,
    state,
    createAddress,
    updateAddress,
    modifyAddress,
  }
}